import HomeIcon from "../Icon/Home";
import AboutIcon from "../Icon/About";
import ProjectsIcon from "../Icon/Projects";
import ContactIcon from "../Icon/Contact";

export const PAGES = [
  {
    to: "/",
    title: "Home",
    Icon: HomeIcon,
  },
  {
    to: "/about",
    title: "About",
    Icon: AboutIcon,
  },
  {
    to: "/projects",
    title: "Projects",
    Icon: ProjectsIcon,
  },
  {
    to: "/contact",
    title: "Contact",
    Icon: ContactIcon,
  },
];
